import { Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight, faSquareNfi } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import { GsapService } from '../../core/services/gsap.service';
import { MasterService } from '../../core/services/master.service';
import { eClick } from '../../core/services/entities';
import { HaylieService } from '../../core/services/haylie.service';

@Component({
  selector: 'app-modalities.component',
  imports: [FontAwesomeModule],
  templateUrl: './modalities.component.html',
  styleUrl: './modalities.component.scss',
})
export class ModalitiesComponent {
  faIcon=faSquareNfi;
  faIcon2=faSquareNfi;
  faArrow = faArrowRight;
  faWhatsapp=faWhatsapp;

  private gsap = inject(GsapService);
  private _svc_haylie = inject(HaylieService);
  private _svc_master = inject(MasterService);

  ngOnInit() { this.gsap.anima_trg('pages-mods.jiu'); }
  
  navigate(p_to:string): void { 
    switch(p_to) {
      case "jiu":
        this.gsap.anima_trg('pages-mods.jiu'); 
        break;
      case "funcional":
        this.gsap.anima_trg('pages-mods.funcional');
        break;

      case "regclick":
        var click = new eClick();
        this._svc_haylie.send_click(click); 
        break;

      default: 
        this._svc_master.navigate(p_to); 
        break;
    }
  }
}
